module.exports = __webpack_public_path__ + "img/24.0d6eb7fd.svg";